import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  async function loginSession(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) throw new Error('Invalid credentials');
      await res.json();
      navigate('/home');
    } catch (err: unknown) {
      setMessage(err instanceof Error ? err.message : 'Login failed');
    }
  }

  return (
    <AuthLayout title="Sign in">
      <p className="mb-4 text-sm text-muted-foreground">Use your Bright.Blue Google account.</p>
      <Button asChild className="w-full">
        <a href="/auth/google">Continue with Google</a>
      </Button>
      {showPassword ? (
        <form className="mt-4 space-y-4" onSubmit={loginSession}>
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <PasswordInput
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <Button type="submit" className="w-full">Login</Button>
          <div className="text-right">
            <a href="/forgot" className="text-sm text-primary underline-offset-4 hover:underline">Forgot password?</a>
          </div>
          {message ? <p className="text-sm text-destructive">{message}</p> : null}
        </form>
      ) : (
        <div className="mt-4 text-center">
          <Button type="button" variant="link" className="h-auto p-0" onClick={() => setShowPassword(true)}>
            Sign in with email and password
          </Button>
        </div>
      )}
    </AuthLayout>
  );
}
